"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SEARCHER_THEME = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdReact = _interopRequireDefault(require("@bit/gerenciatd.react.text-field"));

var _gerenciatdReact2 = _interopRequireDefault(require("@bit/gerenciatd.react.search-button"));

require("./Searcher.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Stateless component to draw Seracher depends on TextField
 * @param {string} wrapperClass class that wraps our component.
 * @param {function} handleSubmit A function from parent to handle submit
 * @param {function} handleOnChange A function from parent to handle input change
 * @param {string} theme A string that indicates the searcher theme from SEARCHER_THEME object
 * @param {string} placeholder Placeholder of input if needed
 * @param {string} buttonVisible true if button has to be visible and false otherwise
 * @param {object} buttonConfiguration title and icon for button if needed 
 * @returns {JSX} Component JSX.
 */
var SEARCHER_THEME = {
  WHITE: 'White',
  GRAY: 'Gray'
};
exports.SEARCHER_THEME = SEARCHER_THEME;

var Searcher =
/*#__PURE__*/
function (_Component) {
  _inherits(Searcher, _Component);

  function Searcher() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Searcher);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Searcher)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (stringSearch) {
      var handleOnChange = _this.props.handleOnChange;

      _this.setState({
        stringSearch: stringSearch
      });

      handleOnChange(stringSearch);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (evt) {
      var handleOnSubmit = _this.props.handleOnSubmit;
      var stringSearch = _this.state.stringSearch;
      evt.preventDefault();
      handleOnSubmit(stringSearch);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (evt) {
      evt.target.select();
    });

    _this.state = {
      stringSearch: ''
    };
    return _this;
  }
  /* Sets the input of the user and send it to parent */


  _createClass(Searcher, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          wrapperClass = _this$props.wrapperClass,
          theme = _this$props.theme,
          placeholder = _this$props.placeholder,
          buttonVisible = _this$props.buttonVisible,
          title = _this$props.title,
          classIcon = _this$props.classIcon,
          autocomplete = _this$props.autocomplete;
      var buttonConfiguration = {};

      if (title) {
        buttonConfiguration.title = title;
      }

      if (classIcon) {
        buttonConfiguration.classIcon = classIcon;
      }

      var autocompleteInput = 'off';

      if (autocomplete) {
        autocompleteInput = 'on';
      }

      return _react.default.createElement("form", {
        className: "Searcher theme".concat(theme, " ").concat(wrapperClass),
        onSubmit: this.handleSubmit
      }, _react.default.createElement(_gerenciatdReact.default, {
        type: "search",
        name: "buscador",
        id: "searcher",
        onChange: this.onChange,
        wrapperClass: "desktopSearcher",
        placeholder: placeholder,
        onFocus: this.handleFocus,
        autocomplete: autocompleteInput
      }), buttonVisible && _react.default.createElement(_gerenciatdReact2.default, buttonConfiguration));
    }
  }]);

  return Searcher;
}(_react.Component);

Searcher.propTypes = {
  wrapperClass: _propTypes.default.string,
  theme: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  handleOnSubmit: _propTypes.default.func.isRequired,
  handleOnChange: _propTypes.default.func,
  buttonVisible: _propTypes.default.bool,
  classIcon: _propTypes.default.string,
  title: _propTypes.default.string,
  autocomplete: _propTypes.default.bool
};
Searcher.defaultProps = {
  wrapperClass: '',
  theme: SEARCHER_THEME.GRAY,
  placeholder: '',
  handleOnChange: function handleOnChange() {},
  buttonVisible: true,
  buttonConfiguration: null,
  classIcon: '',
  title: '',
  autocomplete: false
};
var _default = Searcher;
exports.default = _default;

//# sourceMappingURL=index.js.map